// src/context/AuthReducer.ts
export type UserData = {
  id: number;
  name: string;
  email: string;
  roles: string[];
};

export type AuthState = {
  token: string;
  user: UserData | null;
};

export type AuthActionType =
  | { type: 'LOGIN_SUCCESS'; payload: { token: string; user: UserData } }
  | { type: 'LOGOUT' };

export const AuthReducer = (
  state: AuthState,
  action: AuthActionType
): AuthState => {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      localStorage.setItem('token', action.payload.token);
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      return {
        ...state,
        token: action.payload.token,
        user: action.payload.user,
      };
    case 'LOGOUT':
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      return {
        ...state,
        token: '',
        user: null,
      };
    default:
      return state;
  }
};
